import styled, { css } from "styled-components/macro";
import React from "react";


const Recommendation = styled.div`
  display: flex;
    flex-direction: row;
    padding-top: 14px;
    padding-left: 8px;
    align-items: center;
    justify-content: flex-start;
    gap: 4px;
`;

const Typography1 = styled.div`
  height: 20px;
  padding-left: 18px;
  top: 178px;
  font-family: 'Noto Sans';
  font-style: normal;
  font-size: 16px;
  line-height: 20px;
  color: #273139;
`;

const CloudResourcesType = styled.span`
font-style: normal;
font-weight: 600;
font-size: 14px;
line-height: 20px;
color: #273139;
`;

const Flex = styled.div`
  display: flex;
  flex-direction: row;
  
`;

const SpanWithMargin = styled.span`
  margin-right: 10px; // Change the value as per your need
`;

const ResourcesWidget = ({
                             resourcedata,
                       }: {
    resourcedata: CloudResourcesType;
}) => {
    var cacheIcon = resourcedata.CacheIcon;
    var resourceType = resourcedata.ResourceType;
    var cacheName = resourcedata.CacheType;
    var registryIcon = resourcedata.RegistryIcon;
    var registryName = resourcedata.RegistryName
    return (
        <Flex>
            <Typography1>
                <Recommendation>
                    <CloudResourcesType>{resourceType}</CloudResourcesType>
                </Recommendation>
            </Typography1>
            <Typography1>
                <Recommendation>
                    <img src={cacheIcon}/>
                    <SpanWithMargin>{cacheName}</SpanWithMargin>
                    <img src={registryIcon}/>
                    <span>{registryName}</span>
                </Recommendation>
            </Typography1>
        </Flex>
    );
};

export default ResourcesWidget;